
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.ArrivalDepartureDeviation = {

  template(data) {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: data.label,
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'check_deviation_distance',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    name: 'check_deviation_distance',
                    'maxlength': '10',
                    size: '11',
                    id: 'check_deviation_distance',
                    class: 'modelAttribute textField numberPicker mandatory',
                    autocomplete: 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.coordinateCriteria'),
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'label_coordinate_criteria',
                style: 'margin-top: 10px'
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'infoCoordinate',
                    id: 'radio_info_equip',
                    class: 'modelAttribute radioField',
                    checked: 'true',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.onlyEquipInfo'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'onlyEquipInfo',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'infoCoordinate',
                    id: 'radio_info_mobile',
                    class: 'modelAttribute radioField',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.onlyMobileInfo'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'onlyMobileInfo',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'infoCoordinate',
                    id: 'radio_info_both',
                    class: 'modelAttribute radioField',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.bothInfo'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'bothInfo',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.departureCriteria'),
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'label_departure_criteria',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'infoDeparture',
                    id: 'radio_within_distance',
                    class: 'modelAttribute radioField',
                    checked: 'true',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.withinDistance'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'withinDistance',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'infoDeparture',
                    id: 'radio_farther_distance',
                    class: 'modelAttribute radioField',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.arrivalDepartureDeviation.fartherDistance'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'fartherDistance',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
            id: 'ArrivalDepartureDeviationEvent'
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    let value, formatedValue = null;

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      if (Monet.Session.User.unitSystem !== 'METRIC') {
        value = new BigInt(jsonParam.distanceMeters) * 0.00062137;
        formatedValue = ((Math.round(value * 100)) / 100);
      } else {
        formatedValue = jsonParam.distanceMeters;
      }

      $('#check_deviation_distance').val(formatedValue);

      document.getElementById('radio_info_equip').checked = jsonParam.checkInfoEquipment;
      document.getElementById('radio_info_mobile').checked = jsonParam.checkInfoMobile;
      document.getElementById('radio_info_both').checked = jsonParam.checkInfoBoth;

      document.getElementById('radio_within_distance').checked = jsonParam.checkWithinDistance;
      document.getElementById('radio_farther_distance').checked = jsonParam.checkFartherDistance;

      
    }
  },
  retrieveParameter() {
    let distance, checkInfoMobile;

    if (Monet.Session.User.unitSystem !== 'METRIC') {
      distance = $('#check_deviation_distance').val() / 0.00062137;
    } else {
      distance = $('#check_deviation_distance').val();
    }

    distance = parseInt(distance, 10);
    const radioOnlyEquipInfo = document.getElementById('radio_info_equip').checked;
    const radioOnlyMobileInfo = document.getElementById('radio_info_mobile').checked;
    const radioBothInfo = document.getElementById('radio_info_both').checked;

    const radioWithinDistance = document.getElementById('radio_within_distance').checked;
    const radioFartherDistance = document.getElementById('radio_farther_distance').checked;

    return JSON.stringify({
      distanceMeters: distance,
      checkInfoEquipment: radioOnlyEquipInfo,
      checkInfoMobile: radioOnlyMobileInfo,
      checkInfoBoth: radioBothInfo,
      checkWithinDistance: radioWithinDistance,
      checkFartherDistance: radioFartherDistance
    });
  },

};
